import { CommonModule, CurrencyPipe, LowerCasePipe, UpperCasePipe } from "@angular/common";
import { Component, OnInit, Input } from "@angular/core";
import { GigService } from '../../core/gig.service';
import { environment } from '../../../environments/environment';
import { globals } from '../../../environments/globals';

@Component({
    selector: 'gig-card',
    templateUrl: './gig-card.html',
    standalone: true,
    imports: [CommonModule, CurrencyPipe, LowerCasePipe, UpperCasePipe]
})
export class GigCardComponent implements OnInit {
  appURL: string = environment.appURL;
  mediaURL: string = environment.mediaURL;
  @Input() id: string = '';
  @Input() uid: string = '';
  
  gig: any;
  directory: any = globals.directory;
  directory_data: any;

  constructor(
    private gs: GigService,
  ) {}

  ngOnInit() {
    if (this.id) {
      this.gig = this.gs.gigDetail(this.id).subscribe(gig => {
        this.gig = gig;
        if(this.gig.country) {
          this.directory_data = this.directory[this.gig.country];
        }
      })
    }
  }
}
